






















































import Component from 'vue-class-component'
import { Emit, Mixins, Prop } from 'vue-property-decorator'

import Tags from '../../../Tags/Tags.vue'
import { PlaceholdersOnes, PlaceholdersStack, PlaceholdersType } from './../Toolbar/types'
import PlaceholderSections from './components/PlaceholderSections.vue'
import PlaceholderValueItem from './components/PlaceholderValueItem.vue'
import PlaceholderMixin from './mixins/PlaceholderMixin'

@Component({
  components: {
    PlaceholderSections,
    PlaceholderValueItem,
    Tags,
  },
  data() {
    return {
      PlaceholdersType
    }
  }
})
export default class PlaceholdersListMobile extends Mixins<PlaceholderMixin>(PlaceholderMixin) {
  @Prop() placeholders!: PlaceholdersOnes | PlaceholdersStack

  @Prop() setPlaceholder!: (str: string) => void

  @Prop() popupTrig!: boolean

  @Emit()
  closeModal() {
    return
  }

  page = 1

  handleSelectSection(payload: {sectionIndex:number, btnIndex:number}):void {
    this.onSelectSection(payload)
    this.page = 2
  }

  insertPlaceholder(placeholder: string): void {
    this.setPlaceholder(placeholder)
    this.closeModal()
  }
}
